export default __webpack_public_path__ + "static/media/mini.24e75195.svg";